import { Timestamp } from 'pbts/google/protobuf/timestamp'

/**
 * Checks if a given protobuf Timestamp is within X days from now.
 * @param timestamp - The protobuf Timestamp to check.
 * @param days - The number of days to compare.
 * @returns `true` if the timestamp is within X days from now, otherwise `false`.
 */
export const isWithinXDays = (timestamp: Timestamp, days: number): boolean => {
    const now = new Date()
    const futureDate = new Date(now)
    futureDate.setDate(now.getDate() + days)

    const timestampMillis = timestamp.seconds * 1000 + Math.floor(timestamp.nanos / 1e6)
    const dateToCheck = new Date(timestampMillis)

    return dateToCheck >= now && dateToCheck <= futureDate
}

/**
 * Checks if a given protobuf Timestamp is more than X days older than now.
 * @param timestamp - The protobuf Timestamp to check.
 * @param days - The number of days to compare.
 * @returns `true` if the timestamp is more than X days older than now, otherwise `false`.
 */
export const isOlderThanXDays = (timestamp: Timestamp, days: number): boolean => {
    const timestampMillis = timestamp.seconds * 1000 + Math.floor(timestamp.nanos / 1e6)

    const nowMillis = Date.now()
    const cutoffMillis = nowMillis - days * 24 * 60 * 60 * 1000

    return timestampMillis < cutoffMillis
}
